import React from 'react';
import { TextField, RaisedButton } from 'material-ui';
import uuid from 'node-uuid';


const FieldAndButton = ({ hintText, errorText, value, label, onTouchTap, onChange, cancelFn }) => (
  <div>
    <TextField
      id={uuid.v1()}
      hintText={hintText}
      hintStyle={{ color: 'rgba(255, 255, 255, 0.5)' }}
      inputStyle={{ color: 'white' }}
      errorText={errorText}
      underlineStyle={{ borderBottomColor: '#00bcd4' }}
      style={{ width: '80%', marginLeft: '8%' }}
      value={value}
      onChange={onChange}
    />
    <div style={{ marginBottom: '8px' }}>
      <RaisedButton
        label="Cancel"
        style={{ minWidth: '68px', marginLeft: '8%' }}
        overlayStyle={{ height: '32px' }}
        buttonStyle={{ height: '32px', lineHeight: '32px' }}
        onTouchTap={cancelFn}
      />
      <RaisedButton
        label={label}
        secondary
        style={{ minWidth: '68px', marginLeft: '8%' }}
        overlayStyle={{ height: '32px' }}
        buttonStyle={{ height: '32px', lineHeight: '32px' }}
        onTouchTap={onTouchTap}
      />
    </div>
  </div>
);

export default FieldAndButton;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-list/left-nav/folder-field-save-button.jsx